/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Conservation
 */
export interface Conservation {
    /**
     * 
     * @type {number}
     * @memberof Conservation
     */
    color: number;
    /**
     * 
     * @type {number}
     * @memberof Conservation
     */
    msaData: number;
}

/**
 * Check if a given object implements the Conservation interface.
 */
export function instanceOfConservation(value: object): value is Conservation {
    if (!('color' in value) || value['color'] === undefined) return false;
    if (!('msaData' in value) || value['msaData'] === undefined) return false;
    return true;
}

export function ConservationFromJSON(json: any): Conservation {
    return ConservationFromJSONTyped(json, false);
}

export function ConservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Conservation {
    if (json == null) {
        return json;
    }
    return {
        
        'color': json['color'],
        'msaData': json['msaData'],
    };
}

export function ConservationToJSON(json: any): Conservation {
    return ConservationToJSONTyped(json, false);
}

export function ConservationToJSONTyped(value?: Conservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'color': value['color'],
        'msaData': value['msaData'],
    };
}

